import { render, staticRenderFns } from "./BatchRun.vue?vue&type=template&id=6f38925c&scoped=true"
import script from "./BatchRun.vue?vue&type=script&lang=js"
export * from "./BatchRun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f38925c",
  null
  
)

export default component.exports